import axios from 'axios';
import { encryptPayload, decryptPayload } from '../utils/cryptoHelper';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://kindaapi.jcsoftwaresolution.in/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 1. Request Interceptor: Encrypt outgoing body
api.interceptors.request.use(
  (config) => {
    // Attach authorization token if present in localStorage or sessionStorage
    const token =
      typeof window !== 'undefined'
        ? localStorage.getItem('token') || sessionStorage.getItem('token')
        : null;
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    const method = config.method ? config.method.toLowerCase() : 'get';

    // Only encrypt POST, PUT, PATCH requests with a body
    if (['post', 'put', 'patch'].includes(method) && config.data) {
      // Do not encrypt file uploads (FormData)
      const isFormData =
        typeof FormData !== 'undefined' && config.data instanceof FormData;
      if (!isFormData) {
        config.data = {
          data: encryptPayload(config.data),
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 2. Response Interceptor: Decrypt incoming response
api.interceptors.response.use(
  (response) => {
    if (response.data && response.data.encrypted && response.data.data) {
      response.data = decryptPayload(response.data.data);
    }
    return response;
  },
  (error) => {
    // 4xx/5xx responses are sent as plain JSON by backend, so no decryption needed
    if (error.response?.data?.encrypted && error.response?.data?.data) {
      error.response.data = decryptPayload(error.response.data.data);
    }
    return Promise.reject(error);
  }
);

export default api;
